import BaseService from '@/features/BaseService';

export default class ProjectService extends BaseService {

  constructor() {
    super('projects');
  }

  static toggleStatus({ id }) {
    return BaseService.request(
      'POST',
      'projects/toggle-status',
      { id },
    );
  }

}



// WEBPACK FOOTER //
// ./src/features/project/ProjectService.js